import { useEffect } from "react";
import { Box, Divider, Drawer, Typography, useMediaQuery } from "@mui/material";
import { Category, Apartment, Dns, Settings } from "@mui/icons-material";
import { Logo } from "./logo";
import { NavItem } from "./nav-item";
import { Link } from "react-router-dom";
import { PostIcon } from "../icons/post";
import { Faq } from "../icons/faq";

const items = [
  {
    href: "/",
    icon: <PostIcon fontSize="small" />,
    title: "Blog",
  },
    {
    href: "/ai-blog",
    icon: <PostIcon fontSize="small" />,
    title: "AI-Blog",
  },
  {
    href: "/faqs",
    icon: <Faq fontSize="small" />,
    title: "FAQ",
  },
  {
    href: "/client-faqs",
    icon: <Faq fontSize="small" />,
    title: "Client FAQ",
  },
  {
    href: "/categories",
    icon: <Category fontSize="small" />,
    title: "Categories",
  },
  {
    href: "/cities",
    icon: <Apartment fontSize="small" />,
    title: "Cities",
  },
  {
    href: "/service-names",
    icon: <Dns fontSize="small" />,
    title: "Service Names",
  },
  {
    href: "/settings",
    icon: <Settings fontSize="small" />,
    title: "Settings",
  },
];

export const DashboardSidebar = (props) => {
  const { open, onClose } = props;
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"), {
    defaultMatches: true,
    noSsr: false,
  });

  useEffect(
    () => {
      if (open) {
        onClose?.();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const content = (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <div>
          <Box
            sx={{
              p:1,
              pl: 2,
              display: "flex",
              flexDirection: "row",
              gap: 1,
              alignItems: "center",
            }}
          >
            <Link to="/">
              <Logo
                sx={{
                  height: 42,
                  width: 42,
                }}
              />
            </Link>
            <Typography variant="overline">{`AlviBeauty`}</Typography>
          </Box>
        </div>
        <Divider
          sx={{
            borderColor: "#2D3748",
            mb: 2,
          }}
        />
        <Box sx={{ flexGrow: 1 }}>
          {items.map((item) => (
            <NavItem
              key={item.title}
              icon={item.icon}
              href={item.href}
              title={item.title}
            />
          ))}
        </Box>
        <Divider sx={{ borderColor: "#2D3748" }} />
      </Box>
    </>
  );

  if (lgUp) {
    return (
      <Drawer
        anchor="left"
        open
        PaperProps={{
          sx: {
            backgroundColor: "neutral.900",
            color: "#FFFFFF",
            width: 280,
          },
        }}
        variant="permanent"
      >
        {content}
      </Drawer>
    );
  }

  return (
    <Drawer
      anchor="left"
      onClose={onClose}
      open={open}
      PaperProps={{
        sx: {
          backgroundColor: "neutral.900",
          color: "#FFFFFF",
          width: 280,
        },
      }}
      sx={{ zIndex: (theme) => theme.zIndex.appBar + 100 }}
      variant="temporary"
    >
      {content}
    </Drawer>
  );
};
